require('./counter');
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './components/App.vue'
import paginate from 'vuejs-paginate'
import router from './router'
import {store} from './store'
import mixinTitle from './utils/mixins/mixinTitle'
import i18n from './i18n'
import Axios from 'axios'
import 'bo-rating-component'
import { defineCustomElements } from 'bo-rating-component/loader'
import ModalQueuePlugin from '@/plugins/modal'
// import {API_URL} from "./constant";
import DragVertical from './utils/drag-vertical'

defineCustomElements(window);
Vue.use(VueRouter);
Vue.use(ModalQueuePlugin);
Vue.mixin(mixinTitle);
Vue.prototype.$http = Axios;
// Vue.prototype.$http.defaults.baseURL = API_URL;
Vue.component('paginate', paginate);
// Vue.config.productionTip = false
Vue.directive("drag-vertical", DragVertical);
const app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {App},
  template: '<App/>',
  mounted() {
      // console.log('App mounted!');
  }
});

export default app